import React, { useRef } from 'react';

import {
  GET_BUY_MOTOR_POLICY_VAR_DETAILS,
  SAVE_QUOTE_TWO_WHEELER,
} from '../queries';
// import {
//   resetProposerDetails,
//   updateBuyMotorPolicy,
// } from '../_graphql/state';
import { updateBuyMotorPolicy,resetProposerDetails } from 'quanta-flows/modules/proposal/motor/state';
// import ProposerDetails from '../../../../common/proposer-details';
import { ProposerDetails } from 'quanta-flows/modules/common/proposer';
import { useQuery } from '@apollo/client';
const { getConfig } = require('../../../../../../lib/intl/followupc');
//SA975
require('dotenv').config();
const FOLLOW_API=getConfig("REACT_APP_FOLLOW_API");
//EA975
export default function ProposerDetailsTwoWheeler({
  goToStep,
  proceedToNextStep,
  setProceedToNextStep,
  setParentAlerts,
  setLoadingStep,
  setCustomLoadingMessage,
  lobCode,
  lobName,
  productCode,
  productName,
  productType,
  ...props
}) {
  const initLoadRef = useRef([]);
  const {
    loading: loadingBuyMotorPolicy,
    error: errorBuyMotorPolicy,
    data: dataBuyMotorPolicy,
    previousData: previousDataBuyMotorPolicy,
  } = useQuery(GET_BUY_MOTOR_POLICY_VAR_DETAILS, {
    fetchPolicy: 'cache-first',
    skip: new Set(initLoadRef?.current)?.size >= 1,
    onCompleted: (_) => {
      initLoadRef.current = [...initLoadRef.current, 1];
    },
  });

  const saveQuoteVariables = ({ lob_code, product_code, values }) => {
    let  trailerArr = [];
    values?.quoteData?.trailerDetails.forEach((_, idx) => {
     trailerArr.push({
         make: values?.quoteData?.trailerDetails[idx].make,
         model: values?.quoteData?.trailerDetails[idx].model,
         regnumber: values?.quoteData?.trailerDetails[idx].regnumber,
         ChassisNumber: values?.quoteData?.trailerDetails[idx].ChassisNumber,
         SI: values?.quoteData?.trailerDetails[idx].SI,
         yearofmanufacture: values?.quoteData?.trailerDetails[idx].yearofmanufacture,
       });
     });
    let riskInput = [];
    values?.coverData?.rawRiskData?.forEach((r) => {
      let covers = [];
      r.covers
        .filter(
          (c) => values?.coverData[`addOnCovers`][c?.name]?.selected,
        )
        .forEach((c) => {
          const { selected, attributes, ...rest } = c;
          let attributesArr = [];
          c?.attributes?.forEach((attribute) => {
            attributesArr.push({
              ...attribute,
              value: attribute?.showOnScreen
                ? `${
                    values?.coverData[`addOnCovers`][`${c?.name}`][
                      `attributes`
                    ][`${attribute?.name}`]
                  }`
                : `${attribute?.defaultValue}`,
            });
          });
          covers.push({
            ...rest,
            attributes: [...attributesArr],
          });
        });
      if (covers?.length !== 0) {
        riskInput.push({
          riskType: r?.riskType,
          covers,
        });
      }
    });
    return {
      input: {
        //added
        quoteNumber: values?.quoteNumber
        ? `${values?.quoteNumber}`
        : '',
        proposalNumber: values?.proposalNumber && values?.isProposalModify
        ? `${values?.proposalNumber}`
        : '',
        quoteCreationDate: values?.quoteCreationDate
        ? `${values?.quoteCreationDate}`
        : '',
        //added
        productType: values?.productType,
        businessType: values?.businessType,
        intermediary: {
          intermediaryCode: values?.intermediaryDetails?.code,
          locationCode: values?.intermediaryDetails?.location,
          fieldUserCode: values?.intermediaryDetails?.fieldUserCode,
        },
        customer: values?.proposerDetails,
        lob: '31',
        product:values?.quoteData?.productVariant?.toLowerCase()?.search('comprehensive') !== -1
        ?'3137'
        :values?.quoteData?.productVariant?.toLowerCase()?.search('liability') !== -1
        ?'3140'
        :'3137',
        location: {
          pinCode: values?.quoteData?.pincode,
          state: values?.quoteData?.state,
        },
        vehicleDetails: {
          make: {
            code: values?.quoteData?.make?.code,
            value: values?.quoteData?.make.value,
          },
          model: {
            code: values?.quoteData?.model?.code,
            value: values?.quoteData?.model?.value,
          },
          variant: {
            code: values?.quoteData?.variant?.code,
            value: values?.quoteData?.variant.value,
          },
          engineNumber: values?.quoteData?.engineNo,
          chasisNumber: values?.quoteData?.chasisNo,
          registrationNumber: values?.quoteData?.regNo,
          manufactureYear: values?.quoteData?.yearOfManufacture,
          regPurchaseDate: values?.quoteData?.dateOfReg,
          fuelType: values?.quoteData?.fuelType,
          seatingCapacity: values?.quoteData?.seatingCapacity,
          cubicCapacity: values?.quoteData?.cubeCapacity,
          vehicleAge: values?.quoteData?.premiumData?.vehicleAge,
          registrationNumberOthers : values?.quoteData?.regNoPart2,
          carryingCapacity: values?.quoteData?.carryingCapacity,
          gvw: values?.quoteData?.gvw,
          carriageType: {
            code: values?.quoteData?.carriageType?.code,
            value: values?.quoteData?.carriageType?.code
          },
          permitType: {
            code: values?.quoteData?.permitType?.code,
            value: values?.quoteData?.permitType?.code
          },
          vehicleuse: {
            code: values?.quoteData?.vehicleuse?.code,
            value: values?.quoteData?.vehicleuse?.code
        },
        natureofgoods:{
          code: values?.quoteData?.natureofgoods?.code,
          value: values?.quoteData?.natureofgoods?.code
        },
         vehiclesubType: {
          code: values?.quoteData?.vehiclesubType?.code,
          value: values?.quoteData?.vehiclesubType?.code
      },
        },
        trailerDetails:trailerArr,
        rtoDetails: {
          rtoAuthCode: values?.quoteData?.rtoAuthorityCode,
          rtoLocCode: values?.quoteData?.rtoLocationCode,
          rtoLocDesc: values?.quoteData?.rtoLocationDesc,
        },
        TP_Policy_Tenure:values?.quoteData?.TP_Policy_Tenure,
        TP_Start_Date:values?.quoteData?.TP_Start_Date,
        TP_End_Date:values?.quoteData?.TP_End_Date,
        isPreviousPolicy:
          values?.quoteData?.anyPreviousPolicyforVehicleTaken ===
          'Yes'
            ? true
            : false,
        previousPolicy: {
          coverType:
            values?.quoteData?.anyPreviousPolicyforVehicleTaken ===
            'Yes'
              ? values?.quoteData?.policyCoverType
              : '',
          policyTenure:
            values?.quoteData?.anyPreviousPolicyforVehicleTaken ===
            'Yes'
              ? values?.quoteData?.policyTenure
              : '',
          insurerName:
            values?.quoteData?.anyPreviousPolicyforVehicleTaken ===
            'Yes'
              ? values?.quoteData?.prevInsurance?.insurerName
              : '',
          policyNumber:
            values?.quoteData?.anyPreviousPolicyforVehicleTaken ===
            'Yes'
              ? values?.quoteData?.prevInsurance?.policyNumber
              : '',
          startDate:
            values?.quoteData?.anyPreviousPolicyforVehicleTaken ===
            'Yes'
              ? values?.quoteData?.policyStartDate
              : '',
          expiryDate:
            values?.quoteData?.anyPreviousPolicyforVehicleTaken ===
            'Yes'
              ? values?.quoteData?.policyExpiryDate
              : '',
        },
        previousClaims: {
          totalClaimCount:
            values?.quoteData?.anyPreviousPolicyforVehicleTaken ===
              'Yes'
            //    &&
            // values?.quoteData?.policyTenureValue
            //   ?.toLowerCase()
            //   ?.trim()
            //   ?.search('annual') !== -1
              ? values?.quoteData?.totalClaimCount
              : '',
          claimsInYear1:
            values?.quoteData?.anyPreviousPolicyforVehicleTaken ===
              'Yes' &&
            values?.quoteData?.policyTenureValue
              ?.toLowerCase()
              ?.trim()
              ?.search('long term') !== -1
              ? values?.quoteData?.noOfClaimsOneYear
              : '',
          claimsInYear2:
            values?.quoteData?.anyPreviousPolicyforVehicleTaken ===
              'Yes' &&
            values?.quoteData?.policyTenureValue
              ?.toLowerCase()
              ?.trim()
              ?.search('long term') !== -1
              ? values?.quoteData?.noOfClaimsTwoYears
              : '',
          claimsInYear3:
            values?.quoteData?.anyPreviousPolicyforVehicleTaken ===
              'Yes' &&
            values?.quoteData?.policyTenureValue
              ?.toLowerCase()
              ?.trim()
              ?.search('long term') !== -1
              ? values?.quoteData?.noOfClaimsThreeYears
              : '',
          prevNCBSlab:
            values?.quoteData?.anyPreviousPolicyforVehicleTaken ===
              'Yes'
              ? values?.quoteData?.previousYearNCBSlab
              : '',
          totalClaimAmount:
            values?.quoteData?.anyPreviousPolicyforVehicleTaken ===
              'Yes'
              ? values?.quoteData?.totalClaimAmount
                ? parseFloat(values?.quoteData?.totalClaimAmount)
                : null
              : null,
          claimFreeYear:
            values?.quoteData?.premiumData?.claimFreeYear,
        },
        financerName: values?.quoteData?.financerName,
        insuredDeclaredValue: {
          suggestedIDV: values?.quoteData?.suggestedIDV,
          firstYearIDV: values?.quoteData?.changedIDV,
        },
        irf1: values?.quoteData?.adjustmentIRF,
        creditScoreDetials: {
          discountOpted:
            values?.quoteData?.getAdditionalCreditScore === 'Yes'
              ? true
              : false,
          idProofType: values?.quoteData?.idProofType,
          idProofNumber: values?.quoteData?.idProofNumber,
          creditScore: values?.quoteData?.premiumData?.creditScore,
        },
        coverType: '',
        tenure: '1',
         productVariant:values?.quoteData?.productVariant,
         isTrailerRequired:values?.quoteData?.isTrailerRequired,
         nooftrailers: values?.quoteData?.nooftrailers,
         towedby: values?.quoteData?.towedby,
         totalIDV:values?.quoteData?.productVariant?.toLowerCase()?.search('liability') !== -1
         ?'0'
         :values?.quoteData?.totalIDV,
         bodyIDV:values?.quoteData?.productVariant?.toLowerCase()?.search('liability') !== -1
         ?'0'
         :values?.quoteData?.bodyIDV,
         changedGVW:values?.quoteData?.changedGVW,
         coverforlamps:values?.quoteData?.coverforlamps==true ?true:false,
         coverforprivateandcommercial:values?.quoteData?.coverforprivateandcommercial==true ?true:false,
         vehicleusedlimitedtoownpremises:values?.quoteData?.vehicleusedlimitedtoownpremises==true ?true:false,
         vehicleuseddrivingtuitions:values?.quoteData?.vehicleuseddrivingtuitions==true ?true:false,
         ImportedVehicle:values?.quoteData?.ImportedVehicle==true ?true:false,
         ConfinedtoOwnPremises:values?.quoteData?.ConfinedtoOwnPremises==true ?true:false,
         SoftCopyDiscount:values?.quoteData?.SoftCopyDiscount==true ?true:false,
         AntiTheftDiscount:values?.quoteData?.AntiTheftDiscount==true ?true:false,
         QuotationRecordNo:previousDataBuyMotorPolicy?.buyMotorPolicy?.QuotationRecordNo,
        riskCovers: riskInput,
        premiumBreakup: {
          //SA975
          idvYear1: (FOLLOW_API==='Y')?(parseFloat(values?.quoteData?.premiumData?.idv)):parseFloat(values?.quoteData?.premiumData?.idv1),
          idvYear2: (FOLLOW_API==='Y')?parseFloat(values?.quoteData?.premiumData.idv2):parseFloat(values?.quoteData?.premiumData.idv2),
          idvYear3: (FOLLOW_API==='Y')?parseFloat(values?.quoteData?.premiumData.idv3):parseFloat(values?.quoteData?.premiumData.idv3),
          netODPremium: (FOLLOW_API==='Y')?parseFloat(
            values?.quoteData?.premiumData?.odpremium,
          ):parseFloat(
            values?.quoteData?.premiumData?.netODPremium,
          ),
          netTPPremium: (FOLLOW_API==='Y')?parseFloat(
            values?.quoteData?.premiumData?.net_tp_premiun,
          ):parseFloat(
            values?.quoteData?.premiumData?.netTPPremium,
          ),
          loadingDiscount: parseFloat(
            values?.quoteData?.premiumData?.loadingDiscount,
          ),
          netPremium: (FOLLOW_API==='Y')?parseFloat(
            values?.quoteData?.premiumData?.premium,
          ):parseFloat(
            values?.quoteData?.premiumData?.netPremium,
          ),
          gst: parseFloat(values?.quoteData?.premiumData?.gst),
          stampDuty: parseFloat(
            values?.quoteData?.premiumData?.stampDuty,
          ),
          //SA975
          totalPremium: (FOLLOW_API==='Y')?parseFloat(
            values?.quoteData?.premiumData?.finalpremium,
          ):parseFloat(
            values?.quoteData?.premiumData?.totalPremium,
          ),
	        NCB: (FOLLOW_API==='Y')?parseFloat(values?.quoteData?.premiumData?.ncbpercentage)
          :parseFloat(values?.quoteData?.premiumData?.NCB,
          ),
          //EA975
          loading: values?.quoteData?.premiumData?.loading
            ? values?.quoteData?.premiumData.loading
            : [],
          //SA975
          discount: (FOLLOW_API==='Y')?([{name:"No Claim Bonus",amount:parseFloat(values?.quoteData?.premiumData.ncbamount)},{name:"Voluntary Excess Discount",amount:parseFloat(values?.quoteData?.premiumData.vddiscount_amt)}])
          :(values?.quoteData?.premiumData?.discount
            ? values?.quoteData?.premiumData.discount
            : []),
          //EA975
        },
        voluntaryDeductibleAmt: parseFloat(
          values?.quoteData?.voluntaryDeductibleAmount,
        ),
        //SA975
        NCB:(FOLLOW_API==='Y')?parseFloat(values?.quoteData?.premiumData?.ncbpercentage)
        :parseFloat(values?.quoteData?.premiumData?.NCB,
        ),
        policy: {
          startDate: values?.quoteData?.policy?.startDate,
          expiryDate: values?.quoteData?.policy?.expiryDate,
      },
        //EA975
      },
    };
  };

  return (
    <>
      {!loadingBuyMotorPolicy && !errorBuyMotorPolicy && (
        <ProposerDetails
          {...{
            REACTIVE_VAR_QUERY: GET_BUY_MOTOR_POLICY_VAR_DETAILS,
            SAVE_QUOTE_QUERY: SAVE_QUOTE_TWO_WHEELER,
            goToStep,
            proceedToNextStep,
            resetProposerDetails,
            saveQuoteVariables,
            setCustomLoadingMessage,
            setLoadingStep,
            setParentAlerts,
            setProceedToNextStep,
            updateReactiveVar: updateBuyMotorPolicy,
            preCustomerType: dataBuyMotorPolicy
              ? dataBuyMotorPolicy?.buyMotorPolicy?.quoteData
                  ?.vehicleOwnerTypeAndGender?.organisationType
              : previousDataBuyMotorPolicy?.buyMotorPolicy?.quoteData
                  ?.vehicleOwnerTypeAndGender?.organisationType,
            preGender: dataBuyMotorPolicy
              ? dataBuyMotorPolicy?.buyMotorPolicy?.quoteData
                  ?.vehicleOwnerTypeAndGender?.gender
              : previousDataBuyMotorPolicy?.buyMotorPolicy?.quoteData
                  ?.vehicleOwnerTypeAndGender?.gender,
            prePermPincode: dataBuyMotorPolicy
              ? dataBuyMotorPolicy?.buyMotorPolicy?.quoteData?.pincode
              : previousDataBuyMotorPolicy?.buyMotorPolicy?.quoteData
                  ?.pincode,
            prePermState: dataBuyMotorPolicy
              ? dataBuyMotorPolicy?.buyMotorPolicy?.quoteData?.state
              : previousDataBuyMotorPolicy?.buyMotorPolicy?.quoteData
                  ?.state,
            prePermDistrict: dataBuyMotorPolicy
              ? dataBuyMotorPolicy?.buyMotorPolicy?.quoteData
                  ?.district
              : previousDataBuyMotorPolicy?.buyMotorPolicy?.quoteData
                  ?.district,
            prePermCityTownVillage: dataBuyMotorPolicy
              ? dataBuyMotorPolicy?.buyMotorPolicy?.quoteData?.city
              : previousDataBuyMotorPolicy?.buyMotorPolicy?.quoteData
                  ?.city,
            ...props,
          }}
        />
      )}
    </>
  );
}
